module.exports = __webpack_public_path__ + "media/images/photo09-1c38696d123757a8d91a5a6e18ec4836.png";